import React from "react";
import { ObjectFieldTemplateProps } from "@rjsf/utils";
import { ObjectFieldTemplate } from "../../../../../../../Submissions/Templates";
import {
  FieldPathProvider,
  useFieldPath,
} from "../../../FieldPathContext/FieldPathContext";
import {
  isFieldSelected,
  useSubmissionsBuilderContext,
} from "../../../SubmissionsBuilderContext";
import { withStopPropagation } from "../../../utils";
import { BuilderFieldWrapper } from "../__styles__/FieldPreviews";

function getNameFromId(id: string) {
  const lastSeparatorIndex = id.lastIndexOf("_");

  if (id === "root" || lastSeparatorIndex === -1) {
    return null;
  }

  return id.substring(lastSeparatorIndex + 1);
}

export function ObjectFieldTemplatePreview(props: ObjectFieldTemplateProps) {
  const id = props.idSchema.$id;
  const name = getNameFromId(id);

  if (!name) {
    return (
      <FieldPathProvider root>
        <ObjectFieldTemplate {...props} />
      </FieldPathProvider>
    );
  }

  return (
    <FieldPathProvider path={name}>
      <GroupInputPreview {...props} />
    </FieldPathProvider>
  );
}

function GroupInputPreview(props: ObjectFieldTemplateProps) {
  const { pathArray } = useFieldPath();
  const { selectField, selectedField } = useSubmissionsBuilderContext();

  const isSelected = isFieldSelected(pathArray, selectedField);

  return (
    <BuilderFieldWrapper
      isGroupWrapper
      role="group"
      aria-label="Field group"
      onClick={withStopPropagation(() => {
        selectField(pathArray);
      })}
      isSelected={isSelected}
    >
      <ObjectFieldTemplate {...props} isSubmissionBuilder />
    </BuilderFieldWrapper>
  );
}
